import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=1f5fd05c&"
import script from "./confirm-dialog.vue?vue&type=script&lang=ts&"
export * from "./confirm-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports